<div class="pageContainer">
    <div class="container-wrapper">
        <div class="action-center-header">
            <div class="wrapper">
                <div class="action-center-title">
                    <img alt="action-center-icon" class="icon" src="../../../assets/action-center-icon.svg" />
                    <span>Action Center</span>
                </div>
            </div>
        </div>
        <div class="actions-tab" id="actions-tab">
            <div class="tabs-container">
                <div *ngFor="let tab of tabs; trackBy: trackByFn" data-id="{{tab.id}}" class="tab hover-pointer"
                    [ngClass]="{'selectedTab': currPageState === tab.name}" (click)="changeTab(tab.name)">
                    {{ tab.name }}
                </div>
            </div>
        </div>

        <ng-container *ngIf="dataLoading; else acContent">
            <div class="loader-container">
                <loader [size]="'large'"></loader>
            </div>
        </ng-container>
        <ng-template #acContent>
            <!-- Header only for My Actions and Recommendations page state -->
            <ng-container *ngIf="currPageState === 'My Actions' || currPageState === 'Recommended'">
                <app-actions-header [currPageState]="currPageState" [pageData]="pageData">
                </app-actions-header>
            </ng-container>
            <app-actions-grid [currPageState]="currPageState" [pageData]="pageData">
            </app-actions-grid>
        </ng-template>
    </div>
</div>